
export class Organization {
  id?: string;
  nome?: string;
  endereco?: string;
  municipio?: string;
  uf?: string;
  pais?: string;
  alias?: string;
  telefone?: string;
  fax?: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      this.nome = data.name;
      if (data.address) {
        for (const item of  data.address) {
            if (item.line) {
              this.endereco = item.line.join();
            }
            if (item.city) {
              this.municipio = item.city;
            }
            if (item.state) {
              this.uf = item.state;
            }
            if (item.country) {
              this.pais = item.country;
            }
        }
      }

      if (data.alias) {
        this.alias = data.alias.join();
      }

      if (data.telecom) {
        for (const item of  data.telecom) {
          if (item.system === 'phone') {
              this.telefone = item.value;
          }
          if (item.system === 'email') {
              this.fax = item.value.toLowerCase();
          }
        }
      }

    }
  }

  public static fromDTO?(data) {
    const pacient = new Organization();
    return pacient;
  }

  public toDTO?() {
    const dto: any = {};

    return dto;
  }

}
